import { Repository, EntityRepository } from 'typeorm';
import {CycleChecker } from '../cycle-checker.entity';
import { PreapredStock } from '../prepared-stock.entity';

@EntityRepository(PreapredStock)
export class MaterialPreperationRepository extends Repository<PreapredStock>{
   
}
